import React from 'react';
import Skeleton from './Skeleton';
import RowV2 from './v2/RowV2';

const Placeholder = ({ rows, children }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, index) => (
        <React.Fragment key={index}>{children}</React.Fragment>
      ))}
    </>
  );
};

const Text = ({ width = 60, random = false, fixed = false, min = 100, max = 160 }) => {
  const getRandomWidth = () => (fixed ? (Math.random() > 0.5 ? min : max) : Math.floor(Math.random() * (max - min + 1)) + min);
  const skeletonWidth = random ? getRandomWidth() : width;

  return <Skeleton skeletonStyle={{ width: `${skeletonWidth}px` }} />;
};

const Icon = ({ width = 16, rounded = false }) => {
  const borderRadius = rounded ? '50%' : '0';

  if (rounded) {
    return <Skeleton skeletonStyle={{ width: `${width}px`, height: `${width}px`, borderRadius }} containerStyle={{ width: `${width}px` }} />;
  }

  return <Skeleton skeletonStyle={{ width: `${width}px` }} containerStyle={{ width: `${width}px` }} />;
};

const Row = ({ children, style }) => {
  return <RowV2 style={style}>{children}</RowV2>;
};

const Left = ({ children }) => {
  return <RowV2.Left>{children}</RowV2.Left>;
};

const Right = ({ children }) => {
  return <RowV2.Right>{children}</RowV2.Right>;
};

/**
 * Renders a Skeleton with a width that can be either a fixed value, a random width, or a user-specified width.
 *
 * @param {number} [width=60] - The default width to use when `random` is `false`.
 * @param {boolean} [random=false] - If `true`, the width will be randomly generated.
 * @param {boolean} [fixed=false] - If `true` and `random` is `true`, the width will be either `min` or `max`. Otherwise, the width will be a random value between `min` and `max`.
 * @param {number} [min=100] - The minimum width to use when generating a random width.
 * @param {number} [max=160] - The maximum width to use when generating a random width.
 *
 * @returns {JSX.Element} A Skeleton component with the calculated width.
 */
Placeholder.Text = Text;
Placeholder.Icon = Icon;
Placeholder.Row = Row;
Placeholder.Left = Left;
Placeholder.Right = Right;

export default Placeholder;
